<template>
  <div class="sectionTitle" :style="{'background-color': background}">
        <span class="text" :style="{color: fontColor}">{{ text }}</span>
        <span class="all" v-if="isShowMore" @click="onAll">查看全部</span>
    </div>
</template>

<script >
export default {
    name: 'sectionTitle',
    data () {
        return {}
    },
    props: {
        text: {
            type: String,
            default: ''
        },
        background: {
            type: String,
            default: ''
        },
        isShowMore: {
            type: Boolean,
            default: true
        },
        fontColor: {
            type: String,
            default: ''
        }
    },
    methods: {
        onAll () {
            this.$emit('onMoreCallBack')
        }
    },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variables'
.sectionTitle
    padding 0 40px 0 20px
    display flex
    justify-content space-between
    height 88px
    line-height 88px
    .text
        font-size 34px
        position relative
        color #333333
        z-index 20
        &:before
            content ''
            opacity 0.3
            background-image: linear-gradient(90deg, #ff6600 0%, #fc2d2d 100%), linear-gradient( #fc2d2d, #fc2d2d);
            width 100%
            height 13px
            display block
            position absolute
            bottom 22px
            left 0
            border-radius 5px

    .all
        font-size 24px
        color #666666
</style>
